import { useTranslation } from "react-i18next";
import { DATE_FORMATS } from "../../../../constants";
import SvgIcon from "../../../../parts/SvgIcon";
import ToolTip from "../../../../parts/tooltip";
import MonthDay from "./MonthDay";

const { DATE_DAY_FORMAT } = DATE_FORMATS;

const daysInWeek = [...Array(7)].map((_, i) => i);

function MonthWeek({
  startOfWeek,
  handleSelectDate,
  selectedDates,
  scheduledSessions,
  handleRemoveMultiple,
  expanded = false,
  editCalendar = false,
  handleEditDate = () => {},
  daysInEditMode = [],
  removing = false,
  columnWidths = null,
}) {
  const { t } = useTranslation("athlete-portal");
  // Build dynamic grid template if columnWidths are provided
  let gridStyle = {};
  if (columnWidths) {
    // columnWidths can be either numbers (which need 'fr' suffix) or strings (like 'minmax(...)')
    const columnsTemplate = columnWidths
      .map((w) => (typeof w === "number" ? `${w}fr` : w))
      .join(" ");
    gridStyle = {
      gridTemplateColumns: editCalendar
        ? `32px ${columnsTemplate}`
        : columnsTemplate,
    };
  }
  return (
    <article className={expanded ? "expanded" : ""} style={gridStyle}>
      {editCalendar && (
        <aside>
          <div className="flex flex-col gap-3">
            <ToolTip id="duplicate" body={t("calendar.monthWeek.duplicateWeek")}>
              <a
                href={`/actions/refresh?modal[type]=calendar-duplicate-week&day=${startOfWeek
                  .clone()
                  .format(DATE_DAY_FORMAT)}`}
              >
                <SvgIcon src="/img/new-icons/duplicate.svg" />
              </a>
            </ToolTip>

            <ToolTip id="progression" body={t("calendar.monthWeek.weekProgression")}>
              <a
                href={`/actions/refresh?modal[type]=progression&day=${startOfWeek
                  .clone()
                  .format(DATE_DAY_FORMAT)}&type=calendar-week`}
              >
                <SvgIcon src="/img/new-icons/percentage-square.svg" />
              </a>
            </ToolTip>
          </div>
          <p className="s1 -rotate-90 whitespace-nowrap">
            {startOfWeek.clone().format("MMM D")} -{" "}
            {startOfWeek.clone().add(6, "days").format("MMM D")}
          </p>
          <div className="invisible" />
        </aside>
      )}
      {daysInWeek.map((day) => {
        const date = startOfWeek.clone().add(day, "days");
        const dayString = date.clone().format(DATE_DAY_FORMAT);
        const isSelected = selectedDates.includes(dayString);

        return (
          <MonthDay
            key={dayString}
            date={date}
            handleSelectDate={handleSelectDate}
            isSelected={isSelected}
            selectedDates={selectedDates}
            scheduledSessions={scheduledSessions}
            handleRemoveMultiple={handleRemoveMultiple}
            expanded={expanded}
            dayString={dayString}
            editCalendar={editCalendar}
            daysInEditMode={daysInEditMode}
            handleEditDate={handleEditDate}
            removing={removing}
          />
        );
      })}
    </article>
  );
}

export default MonthWeek;
